module.exports = __webpack_public_path__ + "static/headerRightBg375-dcf18d520e030e308ec5a7f5573faad0.png";